import { render, staticRenderFns } from "./AssessmentHeader.vue?vue&type=template&id=71dc066a&scoped=true"
import script from "./AssessmentHeader.vue?vue&type=script&lang=ts"
export * from "./AssessmentHeader.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentHeader.vue?vue&type=style&index=0&id=71dc066a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc066a",
  null
  
)

export default component.exports